var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visiable
    ? _c("div", { staticClass: "custom-dialog" }, [
        _c("div", { staticClass: "mask" }),
        _c("div", { staticClass: "dialog-main" }, [
          _c(
            "header",
            { staticClass: "dialog-header" },
            [
              _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _c("svg-icon", {
                staticClass: "close-icon",
                attrs: { "icon-class": "_close2" },
                on: { click: _vm.close },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c("svg-icon", {
                staticClass: "status-icon",
                attrs: {
                  "icon-class":
                    _vm.isMore || _vm.isClearHistory ? "tip_info" : "tip_error",
                },
              }),
              _c("p", { staticClass: "content-text" }, [
                _vm._v(_vm._s(_vm.content)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-bottom" },
            [
              _vm.isMore
                ? _c(
                    "div",
                    { staticClass: "btn btn-kown", on: { click: _vm.cancle } },
                    [_vm._v("我知道了")]
                  )
                : [
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-cancel",
                        on: { click: _vm.cancle },
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        class: {
                          "btn-kown": _vm.isClearHistory,
                          "btn-confirm": !_vm.isClearHistory,
                        },
                        on: { click: _vm.confirm },
                      },
                      [_vm._v(" 确定 ")]
                    ),
                  ],
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }